import { TextProps, TitleProps } from './text.interface';
import * as S from './text.styles';

// Page title
export const PageTitle: React.FC = ({ children }) => <S.PageTitle>{children}</S.PageTitle>;

// Title
export const Title = ({ children, size = 'normal', className = '', bold = true }: TitleProps) => (
  <S.Title $bold={bold} $size={size} className={`${className}`}>
    {children}
  </S.Title>
);

// Text
export const Text = ({
  children,
  size = 'normal',
  className = '',
  letterSpace = false,
  color,
  bold = false,
}: TextProps) => (
  <S.Text $size={size} className={`text ${className}`} $letterSpace={letterSpace} $textColor={color} $bold={bold}>
    {children}
  </S.Text>
);
